module.exports = __webpack_public_path__ + "static/media/top-arrow.358bf136.svg";